import { useInfiniteQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getTagsKey } from '../../utils/keys';
export const useSpaceTags = (options) => {
    const { variables, fields = 'basic', useInfiniteQueryOptions } = options || {};
    const { client } = useTribeClient();
    const tagsKey = getTagsKey(variables);
    return useInfiniteQuery(tagsKey, ({ pageParam: after }) => client.tags.list({ after, ...variables }, fields), useInfiniteQueryOptions);
};
//# sourceMappingURL=useSpaceTags.js.map